import { Link } from "react-router-dom";
import { POSTS } from "@/mocks/gossip";

export default function SpecialShowcase() {
  const featured = POSTS.filter((p) => p.featured).slice(0, 3);
  const one = featured[0];
  const rest = featured.slice(1);

  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
        <div>
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-600 bg-accent-100 rounded-full px-3 py-1 mb-3">
            <i className="ri-vip-crown-line"></i> 专题精选
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
            本期深度围观现场
          </h2>
        </div>
        <p className="text-sm text-foreground-500 hidden md:block">
          不止看热闹，更把来龙去脉讲清楚。
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {/* 主专题 */}
        <Link
          to={`/post/${one.slug}`}
          className="group relative overflow-hidden rounded-3xl min-h-[420px]"
        >
          <img
            src={one.cover}
            alt={`${one.title} - 九一吃瓜专题精选`}
            title={one.title}
            className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent"></div>
          <div className="absolute top-5 left-5 inline-flex items-center gap-1.5 rounded-full bg-background-50/90 text-primary-600 text-xs font-medium px-3 py-1.5">
            <i className="ri-award-line"></i> 专题 · {one.category}
          </div>
          <div className="absolute bottom-0 inset-x-0 p-6 md:p-8">
            <h3 className="text-xl md:text-3xl font-bold text-background-50 leading-snug">
              {one.title}
            </h3>
            <p className="mt-3 text-sm text-background-100/90 line-clamp-2 hidden sm:block max-w-lg">
              {one.summary}
            </p>
            <div className="mt-4 flex items-center gap-4 text-xs text-background-100/80">
              <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{one.views}</span>
              <span className="flex items-center gap-1"><i className="ri-time-line"></i>{one.date}</span>
              <span className="inline-flex items-center gap-1 rounded-full bg-background-50/15 text-background-50 text-xs px-3 py-1 group-hover:bg-accent-500 transition">
                前排围观 <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </div>
        </Link>

        {/* 副专题 */}
        <div className="flex flex-col gap-5">
          {rest.map((p) => (
            <Link
              key={p.id}
              to={`/post/${p.slug}`}
              className="group flex-1 grid grid-cols-1 sm:grid-cols-2 gap-0 overflow-hidden rounded-3xl border border-background-200 bg-background-50 hover:border-accent-200 transition"
            >
              <div className="relative h-44 sm:h-auto overflow-hidden">
                <img
                  src={p.cover}
                  alt={`${p.title} - 九一吃瓜专题精选`}
                  title={p.title}
                  className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:p-6 flex flex-col justify-center">
                <span className="text-xs text-accent-600 font-medium mb-2">{p.category}</span>
                <h3 className="text-base md:text-xl font-bold text-foreground-950 leading-snug group-hover:text-primary-600 transition">
                  {p.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 line-clamp-2 hidden sm:block">
                  {p.summary}
                </p>
                <div className="mt-3 flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{p.views}</span>
                  <span className="flex items-center gap-1"><i className="ri-fire-fill text-primary-500"></i>{p.hot}</span>
                </div>
              </div>
            </Link>
          ))}

          {/* 号召卡 */}
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {[
              { icon: "ri-shield-check-line", t: "理性围观", d: "尊重隐私，不信谣不传谣", c: "secondary" },
              { icon: "ri-flag-line", t: "一手现场", d: "鼓励上传可核实的画面", c: "accent" },
            ].map((b) => (
              <div
                key={b.t}
                className={`rounded-3xl border ${
                  b.c === "secondary" ? "border-secondary-200 bg-secondary-50" : "border-accent-200 bg-accent-50"
                } p-5 flex flex-col justify-center`}
              >
                <span className={`w-10 h-10 flex items-center justify-center rounded-2xl ${
                  b.c === "secondary" ? "bg-secondary-500" : "bg-accent-500"
                } text-background-50`}>
                  <i className={`${b.icon} text-lg`}></i>
                </span>
                <h4 className="mt-3 text-base font-bold text-foreground-900">{b.t}</h4>
                <p className="mt-1 text-xs text-foreground-500">{b.d}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}